export const functionalMapCacheState = {
  cachedModuleCount: 0,
  cachedVersion: 0,
  cachedMap: null as Uint8Array | null,
};
